import { Formik, Form } from 'formik';
import { observer } from 'mobx-react-lite';
import { Button, Grid, Header, Icon, Message, Segment } from 'semantic-ui-react';
import { Rider, RiderFormValues } from '../../../../app/models/permit';
import { getButtonSize, returnPhoneOrEmpty } from '../../../../app/common/util/util';
import { useStore } from '../../../../app/stores/store';
import { RiderFormValidationSchema } from '../../../../app/common/form/FormikFormValidations';
import MyTextInput from '../../../../app/common/form/MyTextInput';
import MyZipCodeInput from '../../../../app/common/form/MyZipCodeInput';
import MyPhoneInput from '../../../../app/common/form/MyPhoneInput';

interface Props {
    rider: Rider
}

export default observer(function PermitDetailedRiderEditForm({ 
    rider
 }: Props) {
    const {permitStore, modalStore} = useStore();
    const {updateTempRider} = permitStore;
    const {closeModal2} = modalStore;
    const buttonSize = getButtonSize();

    function handleCancelBtn(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        e.preventDefault();
        closeModal2();
    }

    return (
        <Formik
            initialValues={rider}
            onSubmit={(formValues: RiderFormValues) => updateTempRider(formValues, rider, 'edit')}
            validationSchema={RiderFormValidationSchema}
        >
            {({handleSubmit, isValid, isSubmitting, dirty}) => (
                <Form className='ui form' onSubmit={handleSubmit} autoComplete='off'>
                    <Grid>
                    <Grid.Column computer={8} tablet={8} mobile={16}>
                        <Segment clearing>
                            <Header content='Home Address' sub color='teal' />
                            <label>First Name</label>
                            <MyTextInput name='firstName' placeholder='First Name' tabIndex={1} />


                            <label>Last Name</label>
                            <MyTextInput name='lastName' placeholder='Last Name' tabIndex={2} />

                            <label>Address</label>
                            <MyTextInput name='address' placeholder='Address' tabIndex={3} />

                            <label>Address 2</label>
                            <MyTextInput name='address2' placeholder='Address 2' tabIndex={4} />

                            <label>City</label>
                            <MyTextInput name='city' placeholder='City' tabIndex={5} />

                            <label>Zip Code</label>
                            <MyZipCodeInput name='zipcode' placeholder='Zip Code' tabIndex={6} />

                            {!isValid && returnPhoneOrEmpty(rider.phone) === '' && (
                                <Message icon color='red'>
                                    <Icon name='exclamation' />
                                    <Message.Content>
                                        <Message.Header>Invalid Phone</Message.Header>
                                        Please re-enter phone number as the following format (123) 123-1234.
                                    </Message.Content>
                                </Message>
                            )}
                            <label>Phone</label>
                            <MyPhoneInput name='phone' placeholder='Phone' tabIndex={7} />
                        </Segment>
                    </Grid.Column>
                    <Grid.Column computer={8} tablet={8} mobile={16}>
                        <Segment>
                            <Header content='Work Destination' sub color='teal' />
                            <label>Company/Place</label>
                            <MyTextInput name='employerName' placeholder='Employer Name' tabIndex={8} />

                            <label>City</label>
                            <MyTextInput name='employerCity' placeholder='Employer City' tabIndex={9} />


                            <label>Zip Code</label>
                            <MyZipCodeInput name='employerZipcode' placeholder='Employer Zip Code' tabIndex={10} />
                        </Segment>
                    </Grid.Column>
                    <Grid.Column width={16}>
                        <Button
                            content='Cancel'
                            size={buttonSize}
                            onClick={(e) => handleCancelBtn(e)}
                        />
                        <Button 
                            disabled={!dirty || !isValid}
                            loading={isSubmitting}
                            floated='right'
                            positive
                            type='submit'
                            content={'Edit Rider'}
                            size={buttonSize}
                        /> 
                        </Grid.Column>
                    </Grid>
                </Form>
            )}
        </Formik>
    )
})